'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router';

import 'styles/ListItemCell.scss';

const propTypes = {
    label: PropTypes.string,
    id: PropTypes.string,
    hideIfEmpty: PropTypes.bool,
};

const ListItemCell = (props) => {

    var label = props.label ? <div className="lic-label">{props.label}</div> : null;
    var content = props.content !== null ? <div className="lic-content">{props.content}</div> : null;
    var classes = classNames(
        'list-item-cell',
        props.className
    );

    if (props.link) {
        content = (
            <Link to={props.link} className="hyperlink">
                {content}
            </Link>
        );
    }

    return (
        (!props.hideIfEmpty || props.content) && (
            <span id={props.id} className={classes}>
                {label}
                {content}
            </span>
        )
    );
};

ListItemCell.propTypes = propTypes;

export default ListItemCell; 